<template>
  <div>
    <header id="gHeader" class="f-header js-f-header position-relative">
      <div class="f-header__mobile-content">
        <button class="reset anim-menu-btn js-anim-menu-btn f-header__nav-control js-tab-focus" aria-label="Toggle menu">
          <i class="anim-menu-btn__icon anim-menu-btn__icon--close" aria-hidden="true"></i>
        </button>
      </div>
      <div class="mainNav">
        <div class="mainLogo">
          <h1 :title="$t('MAIN_TITLE.YEAR')">
            <router-link to="/" :title="$t('MAIN_TITLE.YEAR')">
              <!-- <a href="./" title="2021 Thermaltake CaseMOD Invitational" class="logoTher"></a> -->
              <img src="@/assets/images/logo_tt.png" alt="$t('MAIN_TITLE.YEAR')">
              {{ $t('MAIN_TITLE.YEAR') }}
              <span>{{ $t('MAIN_TITLE.SEASON') }}</span>
            </router-link>
          </h1>
        </div>

        <div class="f-header__nav gMenu" role="navigation">
          <div class="f-header__nav-grid justify-between@md max-width-lg">

            <ul class="f-header__list flex-grow flex-basis-0 justify-center@md">
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}`" class="f-header__link">{{ $t('NAV.HOME') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/modderView/1`" class="f-header__link">{{ $t('NAV.MODDER_PROFILE') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/newsList`" class="f-header__link">{{ $t('NAV.NEWS') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/rulesPrizes`" class="f-header__link">{{ $t('NAV.RULES_AND_PRIZES') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/judge`" class="f-header__link">{{ $t('NAV.JUDGES') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/video`" class="f-header__link">{{ $t('NAV.VIDEO') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/winner`" class="f-header__link">{{ $t('NAV.WINNER') }}</router-link>
              </li>
              <li class="f-header__item">
                <router-link :to="`/${$i18n.locale}/voteNow`" class="f-header__link">{{ $t('NAV.VOTE_NOW') }}</router-link>
              </li>
              <li class="f-header__item">
                <a href="http://3dmakers.thermaltake.com/modderGallery.aspx" :title="$t('NAV.MODDER_ALBUM')" target="_blank">{{ $t('NAV.MODDER_ALBUM') }}</a>
              </li>
              <li class="f-header__item">
                <a href="https://casemod.thermaltake.com/join.aspx" :title="$t('NAV.JOIN_TT_MOD')">{{ $t('NAV.JOIN_TT_MOD') }}</a>
              </li>
            </ul>

          </div>
        </div>
      </div>
      <div class="searchBox">
        <div class="communBox">
          <ul>
            <li><a href="https://www.facebook.com/ThermaltakeInc" title="Facebook" target="_blank"><font-awesome-icon :icon="[`fa-brands`, `facebook-square`]"/></a></li>
            <li><a href="https://www.youtube.com/user/Thermaltakereview" title="Youtube" target="_blank"><font-awesome-icon :icon="[`fa-brands`, `youtube-square`]"/></a></li>
            <li><a href="https://twitter.com/thermaltake" title="Twitter" target="_blank"><font-awesome-icon :icon="[`fa-brands`, `twitter-square`]"/></a></li>
          </ul>
        </div>
        <div class="selCont">
          <select class="inBoxC" v-model="$i18n.locale" @change="localeChange">
            <option value="en">English</option>
            <option value="tw">繁體中文</option>
            <option value="cn">簡體中文</option>
            <!-- <option value="http://casemod.thermaltake.com/2021s1/cn">简体中文</option> -->
            <!-- <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
              {{ lang }}
            </option> -->
          </select>
          <!-- <select name="" class="inBoxC" @change="changeLanguage">
            <option value="en">English</option>
            <option value="tw">繁體中文</option>
          </select> -->
          
          <select name="" class="inBoxC rwdHide" onchange="window.open(this.options[this.selectedIndex].value)">
            <option value="http://casemod.thermaltake.com/2019s2/">2021 CaseMOD S1</option>
            <option value="http://casemod.thermaltake.com/2019s2/">2019 CaseMOD S2</option>
            <option value="http://casemod.thermaltake.com/2019s1/">2019 CaseMOD S1</option>
            <option value="http://casemod.thermaltake.com/2018s2/">2018 CaseMOD S2</option>
            <option value="http://casemod.thermaltake.com/2018s1/">2018 CaseMOD S1</option>
            <option value="http://casemod.thermaltake.com/MFCs2/">MFC S2</option>
            <option value="http://casemod.thermaltake.com/2017s1/">2017 CaseMOD S1</option>
            <option value="http://casemod.thermaltake.com/2016s2/">2016 CaseMOD S2</option>
            <option value="http://casemod.thermaltake.com/2016s1/">2016 CaseMOD S1</option>
            <option value="http://casemod2015.thermaltake.com/SEASON2/HOME.HTML">2015 CaseMOD S2</option>
            <option value="http://casemod2015.thermaltake.com/season1/home.html">2015 CaseMOD S1</option>
          </select>
        </div>
      </div>
    </header>
    <div class="rwdLogo">
      <!-- <a href="./" title="2021 Thermaltake CaseMOD Invitational" class="logoTher"></a> -->
      <h1 title="2021 Thermaltake RAM MOD Invitational Season 1">
        <router-link to="/" title="2021 Thermaltake RAM MOD Invitational Season 1">
          2022 Thermaltake CaseMOD Invitational
          <span>Season 1</span>
        </router-link>
      </h1>
    </div>
  </div>
</template>

<style lang="scss">
@use "~codyhouse-framework/main/assets/css/base/breakpoints" as *;
@use "~codyhouse-framework/main/assets/css/base/mixins" as *;
@import "@/assets/scss/common/flexi-header";

.f-header {
  height: 110px;
  background-color: rgba(0,0,0,1);
  font-family: 'Squada One', cursive;
}
.mainLogo {
  // left: 20px;
  margin: 0 auto;
  // padding: 20px 0;
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}
.mainLogo h1 {
  float: none;
  width: 70%;
  /* height: 50px; */
  padding: 0;
  margin: 0 auto;
  border: 0;
  font-size: 30px;
  text-align: center;
}

.mainLogo h1 a {
  display: block;
  width: 100%;
  color: #FFF;
  text-decoration: none;
}
.mainLogo h1 span {
  display: inline-block;
  font-size: 20px;
  position: absolute;
  right: 0;
  top: 75%;
}
.mainLogo img {
  width: auto;
  max-width: 100%;
  display: inline-block;
  vertical-align: middle;
  padding: 0 20px 0 0;
}
.f-header__nav {
  position: static;
  padding: 0;
  height: auto;
  width: auto;
  overflow: visible;
  background: transparent;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}
.f-header__item {
  font-size: 15px;
  margin: 0 15px;
}
.f-header__link {

  height: 70px;
  line-height: 70px;
  padding: 0;
  color: #ffffff;
  overflow: visible;
  border-bottom: none;
  -webkit-transition: color 0.3s, box-shadow 0.3s;
  -moz-transition: color 0.3s, box-shadow 0.3s;
  transition: color 0.3s, box-shadow 0.3s;
  letter-spacing: 1px;
  font-size: 19px;
}
.f-header__link:hover, .f-header__link[aria-current=page], .f-header__dropdown-control:hover, .f-header__dropdown-control[aria-current=page], .f-header__dropdown-link:hover, .f-header__dropdown-link[aria-current=page] {
  color: #eb6d00;
}
.f-header__nav::before {

  top: 0;
  height: 0;
  border-bottom: 0;
}
.f-header__mobile-content {
  top: 0;
  position: absolute;
}
.anim-menu-btn__icon {
  background-image: linear-gradient(#FFF, #FFF);
}
@media (min-width: 64rem) {
  .mainLogo {
    padding: 10px 0;
  }
  .mainLogo h1 {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    font-size: 45px;
    letter-spacing: 1px;
    font-family: 'Squada One', cursive;
  }
  .f-header {
    height: auto;
    width: 100%;
    top: 0;
    background-color: rgba(0,0,0,1);
    font-family: 'Squada One', cursive;
    z-index: 999;
  }
  .f-header__item {
    position: static;
  }
  .f-header__dropdown {
    width: 100%;
    background-color: rgba(0,0,0,0.7);
    padding: 5%;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
    -webkit-transition: opacity .3s 0s, visibility 0s 0s;
    -moz-transition: opacity .3s 0s, visibility 0s 0s;
    transition: opacity .3s 0s, visibility 0s 0s;
    left: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .f-header__dropdown li {
    height: auto;
    width: 20%;
    float: left;
    overflow: hidden;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .f-header__dropdown-link {
    color: #FFF;
    height: 30px;
    line-height: 30px;
    padding: 5px 1%;
    text-align: center;
    border-bottom: none;
    font-size: 1.4rem;
  }
  .f-header__dropdown-link:hover {
    // background-color: hsla(var(--color-contrast-higher-h), var(--color-contrast-higher-s), var(--color-contrast-higher-l), 0.075);
    background-color: transparent;

  }
}

#gHeader h1, #gHeader h1 a {
  font-family: 'Oswald', sans-serif;
  height: auto !important;
}
@media screen and (max-width: 1600px) {
  .f-header__item {
    margin: 0 10px;
  }
  .justify-center\@md {
    justify-content: left !important;
  }
}

@media screen and (max-width: 1024px) {
  #gHeader {
    height: 70px !important;
  }
}

</style>

<script>
import { watch, onMounted, reactive, ref } from "vue"
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'NavBar',
  // props: ['modders'],
  data() {
    return {
      nowLang: this.$route.params.lang
    }
  },
  inject: ['emitter'], // 內層元件用Inject的方式把emitter讀進來
  computed: { // i18n!!!!!!!!!! 偵測切換語系改變，把語系push上去網址
    localeChange() {
      console.log('localeChange', this.$i18n.locale)
      this.$router.push({
        params: { lang: this.$i18n.locale }
      })
    }
  },
  // i18n!!!!!!!!!!
  setup() {
    const { t, locale } = useI18n();
    const router = useRouter();
    const route = useRoute();
    // const changeLanguage = (e) => {
    //   locale.value = e.target.value;
    // };
    onMounted(async () => {
      await router.isReady();
      const watchLang = route.params.lang;
      // console.log('watchLang', watchLang)
      // locale._value = watchLang;
      // console.log('locale', locale._value)
    })
    watch(locale, (newLang, oldLang) => { // i18n!!!!!!!!!! 把當前語系狀態存在 localStorage
      console.log('Language', newLang, oldLang)
      // this.$i18n = locale
      localStorage.setItem("locale", newLang);
      // router.push({
      //   params: { lang: newLang }
      // })
    });
    return {
      t,
      locale,
      // changeLanguage,
    }
  },
  methods: {
    routerPush (id) {
      // this.$emit('link-id', id)
      this.$router.push('/')
      this.emitter.emit('emitLinkId', id)
    }
  },
  created() {
    // this.$watch(
    //   () => this.$route.params.lang,
    //   (toParams, previousParams) => {
    //     this.$i18n.locale = toParams;
    //     localStorage.setItem("locale", toParams);
    //     // this.$router.push({
    //     //   params: { lang: toParams }
    //     // })
    //     console.log('this.$route.params', this.$route.params.lang, this.$i18n.locale, toParams, previousParams)
    //     // this.$i18n.locale = this.$route.params.lang
    //   }
    // )
  },
  mounted () {
    const frontEnd = document.createElement('script')
    frontEnd.setAttribute('src', './flexi-header.js')
    frontEnd.setAttribute('id', 'flexi-header-js')

    document.body.appendChild(frontEnd)
    // 在這邊用 this.$i18n.locale，如果在 router 檔案裡面就可以用 i18n.global.locale

    // const availibleLocales = this.$i18n.availableLocales;
    // const usersLanguage = window.navigator.language
    // if (availibleLocales.includes(usersLanguage)) {
    //   this.$i18n.locale = language;
    // } else {
    //   this.$i18n.locale = 'en';
    // }
    // console.log('this.$i18n.locale', this.$i18n.locale, 'availibleLocales', availibleLocales, 'usersLanguage', usersLanguage, 'this.id', this.$route.params)

    this.$watch( // i18n!!!!!!!!!! 如果一開始打網址，會直接執行網址的語系 (這個也搞好久，把上面 setup 的 router.push 註解掉就可以了)
      () => this.$route.params.lang,
      (toParams, previousParams) => {
        this.$i18n.locale = toParams;
        console.log('this.$route.params', this.$route.params.lang, this.$i18n.locale, toParams, previousParams)
      }
    )
  },
  unmounted () {
    document.getElementById('flexi-header-js').remove()
  }
}
</script>
